import { render, staticRenderFns } from "./guahaoxiangqing.vue?vue&type=template&id=350cceb3&scoped=true"
import script from "./guahaoxiangqing.vue?vue&type=script&lang=js"
export * from "./guahaoxiangqing.vue?vue&type=script&lang=js"
import style0 from "./guahaoxiangqing.vue?vue&type=style&index=0&id=350cceb3&prod&rel=stylesheet%2Fless&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "350cceb3",
  null
  
)

export default component.exports